<template>
  <b-modal v-model="modal" hide-footer hide-header ref="modal" @hidden="close">
    <div class="modal-header">
      <h3 v-show="!edit">Dodaj nowego użytkownika</h3>
      <h3 v-show="edit">Edytuj użytkownika</h3>
    </div>
    <div class="modal-body">
      <b-form @submit.stop.prevent="$emit('submit', user)">
        <app-input :model="$schema.email"></app-input>
        <app-input :model="$schema.firstName"></app-input>
        <app-input :model="$schema.lastName"></app-input>
        <app-input v-show="edit" type="password" :model="$schema.password"></app-input>
        <app-input v-show="edit" type="password" :model="$schema.repeatPassword"></app-input>
      </b-form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary mr-1" @click="close">Anuluj</button>
      <button v-show="!edit" class="btn btn-primary mr-1" @click.stop.prevent="addEmployee">Dodaj</button>
      <button
        v-show="edit"
        class="btn btn-primary mr-1"
        @click.stop.prevent="editUser"
      >Zapisz zmiany</button>
    </div>
  </b-modal>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import schema from '@/schemas/employee.schema';
import { UserResource } from '@/resources/user.resource';

export default {
  mixins: [formMixin],
  schema,
  data() {
    return {
      modal: true,
      edit: false,
      pass: '',
      passwordGenerate: false
    };
  },
  props: {
    user: Object,
    addModal: Boolean
  },
  methods: {
    // Dodanie nowego pracownika
    async addEmployee(event) {
      const pw = this.generatePassword(this.$schema.$model);
      if (this.$schema.$validateAll().length > 0) {
        this.$notify({ type: 'error', title: 'Błąd', text: 'Niepoprawnie wypełniony formularz' });
        return;
      }
      try {
        const createdUser = await UserResource.add(this.$schema);
        this.$emit('createNewEmployee', createdUser);
      } catch (error) {
        event.preventDefault();
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    },

    generatePassword(form) {
      this.passwordGenerate = true;
      this.pass = '';
      const chars = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPRSTUWXYZ123456789';

      for (let i = 0; i < 8; i++) {
        const x = Math.floor(Math.random() * chars.length);
        this.pass += chars.charAt(x);
      }
      form.password = this.pass;
      form.repeatPassword = this.pass;
      return form;
    },
    // Edycja użytkownika
    async editUser() {
      if (this.$schema.$validateAll().length > 0) {
        this.$notify({ type: 'error', title: 'Błąd', text: 'Niepoprawnie wypełniony formularz' });
        return;
      }
      const updatedUser = await UserResource.update(this.user.id, this.$schema);
      this.$emit('edited', updatedUser);
    },
    close() {
      this.$schema.$reset();
      this.$emit('cancel');
    }
  },
  beforeMount() {
    if (this.user.email) {
      this.$schema.email.$value = this.user.email;
    }
    if (this.user.firstName) {
      this.$schema.firstName.$value = this.user.firstName;
    }
    if (this.user.lastName) {
      this.$schema.lastName.$value = this.user.lastName;
    }
    this.modal = this.addModal;
    if (this.user.firstName) {
      this.edit = true;
    }
  }
};
</script>
